import { breakpoints } from "@brightagency/headstart-common";
import styled from "styled-components";
import { zIndex } from "../../constants";

export const NavWrapper = styled.div`
    position: relative;
    z-index: ${zIndex.navWrapper};

    & + * {
        position: relative;

        &::before {
            position: relative;
            display: block;
            content: "";
            height: var(--nav-height);
        }
    }

    ${breakpoints.large} {
        & + * {
            margin-top: calc(var(--nav-height) * -1);
        }
    }
`;
